
import { Component, Prop } from 'vue-property-decorator'
import Mixin from '../helpers/mixin'

@Component({
  template: `
  <div
    v-if="!isSubmenu || (isSubmenu && shouldShowSubmenu)"
    :class='{"dropdown-wrapper" : !isSubmenu, "submenu" : isSubmenu}'
  >
    <a
      v-for="item in itemsToShow"
      :href='item.url'
      :class='{"dropdown-item" : !isSubmenu, "submenu-item" : isSubmenu, "is-active": isActiveOrParentPage(item.url)}'
      :title='title(item)'>
      <div class='title'>
        {{ title(item) }}
        <i v-if="!isSubmenu" class='icons8-chevron-right'></i>
      </div>
    </a>

    <a
      v-if='topCategory'
      :href='topCategory.url'
      :class='{"dropdown-item" : !isSubmenu, "submenu-item" : isSubmenu, "is-active": isActiveRelativeUrl(topCategory.url)}'
      :title='menuLabel'
    >
      <div class='title'>
        {{ menuLabel }}
        <i v-if="!isSubmenu" class='icons8-chevron-right'></i>
      </div>
    </a>
  </div>
  `
})
export default class ProductCategoriesDropdownItems extends Mixin {
  @Prop() items: any
  @Prop() topCategories!: any
  @Prop() menuLabel: string
  @Prop() isSubmenu: boolean
  @Prop() shouldShowSubmenu: boolean

  itemsToShow = []
  topCategory: any = null

  created() {
    this.itemsToShow = this.items.toSorted((a: any, b: any) => b.priority - a.priority)
    if (this.topCategories && this.topCategories.length > 0) {
      this.topCategory = this.topCategories.filter((item: any) => !item.url.includes("prefab") && !item.url.includes("fortius"))[0]
    }
  }

  title(item: any): string {
    if (item.heroTitle && item.heroTitle != '') {
      return item.heroTitle
    } else if (item.title !== '') {
      return item.title
    }
    return ''
  }

  isActiveRelativeUrl(url: string): boolean {
    // remove trailing slash
    const currentRelativeUrl = `${location.pathname}`.replace(/\/+$/, '').toLowerCase()
    return currentRelativeUrl === url.toLowerCase()
  }

  currentUrl(): string {
    const currentUrl = `${location.origin}${location.pathname}`
    // remove trailing slash
    return currentUrl.replace(/\/+$/, '').toLowerCase()
  }

  isActiveOrParentPage(url: string): boolean {
    // returns true when url is current url or is parent page
    const urlPieces = url
      .toLowerCase()
      .split('/')
      .filter(urlPiece => urlPiece.length > 0)
    const currentUrlPieces = this.currentUrl().split('/').filter((urlPiece: any) => urlPiece.length > 0)

    if (urlPieces.length === 0) return false

    for (let i = 0; i < urlPieces.length; i++) {
      const index = currentUrlPieces.indexOf(urlPieces[i])

      if (index < 0) return false
      if (i > 0) {
        // after the first one check if the foundindex is one more than the previous one
        const prevIndex = currentUrlPieces.indexOf(urlPieces[i - 1])
        if (prevIndex + 1 !== index) return false
      }
    }
    return true
  }
}
